import { useLiveQuery } from 'dexie-react-hooks';

import db from './db';
import { currentUserId } from './meta';

export function useUnreadActivityCount({ workspaceId = null } = {}) {
  const userId = currentUserId();

  return useLiveQuery(
    () => {
      if (!userId) return 0;

      return db.activities
        .where('recipient_user_id')
        .equals(userId)
        .filter((activity) => {
          if (activity.read_at != null) return false;
          if (workspaceId && String(activity.workspace_id) !== String(workspaceId)) return false;
          return true;
        })
        .count();
    },
    [userId, workspaceId],
    0,
  );
}

export default useUnreadActivityCount;
